import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { PortfolioSegmentDataContext } from '../../data/portfolio-segment-data-context.service';

export interface ExternalReportViewerConfig {
    reportUrl?: string;
}

@Component({
    selector: 'app-external-report-viewer',
    imports: [],
    templateUrl: './external-report-viewer.component.html',
    styleUrl: './external-report-viewer.component.scss'
})
export class ExternalReportViewerComponent {

    protected url: SafeUrl;
    private sanitizer = inject(DomSanitizer);

    private pfSegDataCtx = inject(PortfolioSegmentDataContext);

    constructor(private route: ActivatedRoute) {
        const segmentId = this.pfSegDataCtx.segmentId()!;
        const config = this.route.snapshot.data['config'] as ExternalReportViewerConfig;

        const urlParams = new URLSearchParams();
        urlParams.set('segmentId', segmentId);
        const url = new URL(config.reportUrl as string);
        url.search = urlParams.toString();

        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
    }
}
